import React, { useState, useCallback } from "react";
import { Col } from "react-bootstrap";

import api from "../../scripts/api";
import { message } from "../shared/Message";
import SearchSelect from "../shared/asyncSelect/SearchSelect"

function ClientSearch({ handleSearchSelect }) {
    const [searchState, setSearchState] = useState({
        noOptionsMessage: 'No matching clients found',
        pageSize: 50,
        pageNum: 0
    });

    const searchClients = useCallback(async (searchTerm, loadedOptions, { pageNum, pageSize }) => {
        let result;
        try {
            result = await api.searchClients(searchTerm, pageNum, pageSize);
        } catch (err) {
            message.error(`Error searching for client: ${err}`);
            return { options: [] };
        }

        const searchResults = result.searchResults.map(dto => ({
          value: dto.id,
          label: `${dto.lastName}, ${dto.firstName} (${dto.id})${dto.isDisabled ? ' (Inactive)' : ''}${dto.needsApproval ? ' (Needs approval)' : ''}`
        }));
        const hasMore = result.totalMatches > (pageNum * pageSize) + searchResults.length;

        return {
            options: searchResults,
            hasMore: hasMore,
            additional: {
                pageNum: pageNum + 1,
                pageSize: pageSize
            }
        }
    }, [])

    return (
        <Col>
            <SearchSelect
                placeholder="Search clients"
                noOptionsMessage={() => searchState.noOptionsMessage}
                loadOptions={searchClients}
                additional={{ pageNum: searchState.pageNum, pageSize: searchState.pageSize }}
                onChange={handleSearchSelect}
            />
        </Col>
    )
}

export default ClientSearch;
